const PERSONAL_FILTER_FORM_INITIAL_VALUES = {
    loanAmount: '$15,000',
    creditScoreApprox: 749,
  },
  STUDENT_LOAN_REFI_FILTER_FORM_INITIAL_VALUES = {
    loanAmount: '$60,000',
    creditScoreApprox: 749,
  },
  DEFAULT_ACTIVE_TAB = 'all-rates'

export {
  PERSONAL_FILTER_FORM_INITIAL_VALUES,
  STUDENT_LOAN_REFI_FILTER_FORM_INITIAL_VALUES,
  DEFAULT_ACTIVE_TAB,
}
